import { render, staticRenderFns } from "./ClientRequests.vue?vue&type=template&id=2ba82c6a&scoped=true"
import script from "./ClientRequests.vue?vue&type=script&lang=ts"
export * from "./ClientRequests.vue?vue&type=script&lang=ts"
import style0 from "./ClientRequests.vue?vue&type=style&index=0&id=2ba82c6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba82c6a",
  null
  
)

export default component.exports